import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import store, { AppDispatch } from '../../../data/storeConfig';
import { PrimaryButton } from '../../../shared/components/common/primary_button';
import { TimerButton } from './timer_button';
import * as authActions from '../../../data/reducers/auth.reducer';
import { useSelector } from 'react-redux';
import { RootState } from '../../../data/reducers';
import { useParams } from 'react-router';
import OtpInput from 'react-otp-input-mod';

export const OtpInputComponent = () => {
  const dispatch = useDispatch<AppDispatch>();
  const { storeSlug } = useParams<any>();
  const { phoneNumber, userId, isLoading, isLoggedIn } = useSelector((state: RootState) => state.authReducer);
  const [otp, setOtp] = useState('');
  const { storeInfo } = useSelector((state: RootState) => state.storeReducer);

  const verifyOtp = (e: any) => {
    e.preventDefault();
    if (storeInfo) {
      dispatch(
        authActions.verifyOtp({
          phoneNumber: phoneNumber,
          userId: userId,
          storeSlug: storeSlug ?? '',
          verificationCode: parseInt(otp),
          merchantStoreId: storeInfo?.merchantStoreId,
        }),
      );
    }
  };

  const sendOtp = () => {
    if (storeInfo) {
      dispatch(
        authActions.sendOtp({
          countryCode: '',
          contactNumber: phoneNumber,
          storeSlug: storeSlug ?? '',
          merchantStoreId: storeInfo?.merchantStoreId,
        }),
      );
    }
  };

  return (
    <div className="mx-auto my-auto flex justify-center items-center" style={{ height: '85vh' }}>
      <div className="text-center">
        <h2 className="text-3xl text-theDarkOne font-semibold">Enter OTP</h2>
        <h3 className="text-sm text-theLighterDark">We sent it to {phoneNumber}</h3>
        <form onSubmit={verifyOtp}>
          <div className="flex justify-center my-8">
            <div className="mb-3">
              <OtpInput
                value={otp}
                onChange={(val: any) => setOtp(val)}
                shouldAutoFocus={true}
                isInputNum={true}
                numInputs={4}
                inputStyle={{
                  width: '3rem',
                  height: '3rem',
                  margin: '0 1rem',
                  fontSize: '1.2rem',
                  borderRadius: '8px',
                  border: '1px solid rgba(0, 0, 0, 0.3)',
                }}
                focusStyle={{
                  width: '3rem',
                  height: '3rem',
                  margin: '0 1rem',
                  fontSize: '1.2rem',
                  borderRadius: '8px',
                  border: '1px solid #4245F5',
                  outline: 'none',
                }}
              />
            </div>
          </div>
          <PrimaryButton
            text="Verify"
            isLoading={isLoading}
            onclick={() => {
              console.log('Verify OTP');
            }}
          />
        </form>
        <div className="my-3" />
        <TimerButton duration={120} text="Resend OTP" onclick={sendOtp} />
      </div>
    </div>
  );
};
